import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

import { useEmbeddedViewPageFeatures } from './useEmbeddedViewPageFeatures.ts';

export const useEmbeddedModernHeader = (): boolean => {
	const isEmbeddedConfluence = isEmbeddedConfluence_DO_NOT_USE();
	const { hasModernHeader } = useEmbeddedViewPageFeatures();

	return isEmbeddedConfluence && hasModernHeader;
};
